/*
 * Author: Dw
 * File Created: Wednesday, 25-05-28 02:00 pm
 * Last Modified: Wednesday, 25-06-11 06:37 pm, by Dw
 */

// Only support Node.js runtime
import { metrics, ValueType } from '@opentelemetry/api';

import { Logger } from '../logger';
import { cpuObservableGauge } from './CpuUsageMonitor';

const logger = new Logger({
  module: 'metrics',
});

export const meter = metrics.getMeter('nextjs-metrics');

export const clientDuration = meter.createHistogram('http_client_duration_ms', {
  description: 'Outgoing HTTP duration for whitelisted hosts',
  unit: 'ms',
});

export const middlewareDuration = meter.createHistogram(
  'middleware_duration_ms',
  {
    description: 'Next.js middleware execution duration',
    unit: 'ms',
    valueType: ValueType.DOUBLE,
    advice: {
      explicitBucketBoundaries: [
        25, 50, 75, 100, 250, 500, 750, 1000, 1500, 2500,
      ],
    },
  }
);

export const serverSideDuration = meter.createHistogram('ssr_duration_ms', {
  description: 'Next.js ServerSideProps execute duration',
  unit: 'ms',
  valueType: ValueType.DOUBLE,
  advice: {
    explicitBucketBoundaries: [
      25, 50, 75, 100, 250, 500, 750, 1000, 1500, 2500,
    ],
  },
});

export const openErrorCounter = meter.createCounter('openapi_error_total', {
  description: 'Total number of openapi errors',
  unit: '1',
  valueType: ValueType.INT,
});

export const pageRequestFailureCounter = meter.createCounter(
  'page_request_failure_total',
  {
    description: 'Total number of page request failures',
    unit: '1',
    valueType: ValueType.INT,
  }
);

meter
  .createObservableGauge('node_process_cpu_usage', {
    description: 'Process CPU usage (%)',
    unit: '1',
    valueType: ValueType.DOUBLE,
  })
  .addCallback(async (observableResult) => {
    try {
      if (typeof process.cpuUsage === 'function') {
        cpuObservableGauge(observableResult);
      }
    } catch (e) {
      logger.error('cpuObservableGauge error:', e);
    }
  });
